import { useEffect, useState } from "react";
import { Button, Col, Form, Pagination, Row, Table } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import httpRequest from "./HttpRequestService";
import Trx from "./layout/Trx";

const Home = () => {
    const [token] = useOutletContext();
    const [data, setData] = useState([]);

    const [filter, setFilter] = useState({
        key: [],
        perpage: 10,
        page: 1,
        pages: 1,
        sort: [{ title: 'createdAt', value: -1 }],
        limiter: [],
        metaFilters: []
    });

    const [session, setSession] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const goPage = (page) => load({ ...filter, page });

    const findByField = () => {
        const filtre = { ...filter, page: 1 };
        filtre.key = session !== '' ? [{ title: 'public_id', value: session }] : [];
        filtre.metaFilters = phoneNumber !== '' ? [{ key: 'phoneNumber', value: phoneNumber }] : [];
        load(filtre);
    };

    const load = async (filtre = null) => {
        try {
            const response = await httpRequest(`${token}/trx/list`, { filtre: filtre ?? filter }, false);
            if (response.data) {
                setData(response.data.data);
                setFilter(response.data.filter);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => { load(); }, []);

    const setLimiterDate = (field, value) => {
        let limiter_tmp = [...filter.limiter];
        const limit = limiter_tmp.find(l => l.title === "createdAt");
        if (limit) {
            limiter_tmp[limiter_tmp.indexOf(limit)][field] = value;
        } else {
            limiter_tmp.push({ title: "createdAt", min: null, max: null, [field]: value });
        }
        setFilter({ ...filter, limiter: limiter_tmp });
    };

    const items = [];
    if (filter.page > 1) items.push(
        <Pagination.Item onClick={() => goPage(filter.page - 1)} key="prev">Précédent</Pagination.Item>
    );
    items.push(
        <Pagination.Item onClick={() => goPage(filter.page)} key={filter.page} active>{filter.page}</Pagination.Item>
    );
    if (filter.page < filter.pages) items.push(
        <Pagination.Item onClick={() => goPage(filter.page + 1)} key="next">Suivant</Pagination.Item>
    );

    return (
        <>
            {/* Filter bar */}
            <div className="filter-bar">
                <Row className="g-2 align-items-end">
                    <Col xs={12} md={2}>
                        <Form.Label>Date début</Form.Label>
                        <Form.Control
                            type="date"
                            size="sm"
                            value={filter.limiter.find(l => l.title === "createdAt")?.min || ''}
                            onChange={(e) => setLimiterDate('min', e.target.value)}
                        />
                    </Col>
                    <Col xs={12} md={2}>
                        <Form.Label>Date fin</Form.Label>
                        <Form.Control
                            type="date"
                            size="sm"
                            value={filter.limiter.find(l => l.title === "createdAt")?.max || ''}
                            onChange={(e) => setLimiterDate('max', e.target.value)}
                        />
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Label>Session</Form.Label>
                        <Form.Control
                            type="text"
                            size="sm"
                            placeholder="ID de session..."
                            value={session}
                            onChange={(e) => setSession(e.target.value)}
                        />
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Label>Numéro de paiement</Form.Label>
                        <Form.Control
                            type="text"
                            size="sm"
                            placeholder="Numéro de téléphone..."
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                    </Col>
                    <Col xs={12} md={2} className="d-flex gap-2">
                        <Button variant="primary" size="sm" onClick={findByField} className="flex-fill">
                            🔍 Recherche
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={() => load()} className="flex-fill">
                            ↺ Actualiser
                        </Button>
                    </Col>
                </Row>
            </div>

            {/* Table */}
            <div className="admin-card">
                <div style={{ padding: '12px 16px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '13px', color: '#6c757d' }}>
                        Page <strong>{filter.page}</strong> / {filter.pages}
                    </span>
                    <Pagination size="sm" className="mb-0">{items}</Pagination>
                </div>

                <Table responsive className="table-admin mb-0">
                    <thead>
                        <tr>
                            <th>Message USSD</th>
                            <th>Session</th>
                            <th>API</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Paiement</th>
                            <th>Statut</th>
                            <th>Order ID</th>
                            <th>Passerelle</th>
                            <th>PreCode</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan="11" className="text-center text-muted py-4">
                                    Aucune transaction trouvée
                                </td>
                            </tr>
                        ) : (
                            data.map((dt, index) => <Trx key={index} dt={dt} load={load} />)
                        )}
                    </tbody>
                </Table>

                <div style={{ padding: '8px 16px', display: 'flex', justifyContent: 'flex-end' }}>
                    <Pagination size="sm" className="mb-0">{items}</Pagination>
                </div>
            </div>
        </>
    );
};

export default Home;
